import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import * as Constants from './Constants';
import { ConfigurationManager } from './ConfigurationManager';

@Injectable()
export class DealsProviderService {


    all_deals_encoded = 'All+Deals';

    constructor(private http: HTTP, private config: ConfigurationManager) { }

    getDeals(data, pageno) {
        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };

        let url = this.config.environmentConfig.baseurl + 'deser/v1?';
        url = url + 'Latitude=' + this.config.getLatitude;
        url = url + '&Longitude=' + this.config.getLongitude;
        url = url + '&ScreenTitle=' + data.ScreenTitle;
        url = url + '&SessionID=' + this.config.getSessionId;
        url = url + '&ProxyUI=' + this.config.getProxyUI;
        url = url + '&ClubID=' + this.config.getClubCode;
        url = url + '&FromNewDNR=true';
        url = url + '&SearchTypeID=' + data.SearchTypeID;
        url = url + '&PageSize=20';
        url = url + '&Page=' + pageno;
        if (data.Keyword != null && data.keyword !== '') {
            url = url + '&Keyword=' + data.Keyword;
        }
        if (data.ScreenTitle === Constants.LOCAL.params.name) {
            if (data.CategoryID == null) {
                url = url + '&StoreFrontFlag=true';
            }
        }
        if (data.ScreenTitle === Constants.ONLINE.params.name) {
            url = url + '&OnlineFlag=true';
        }
        if (data.ScreenTitle === 'AAA+Dollars') {
            url = url + '&AAADollarsFlag=true';
        }

        if (data.ScreenTitle === Constants.VACATIONS.params.name) {
            if (data.SearchTypeID === '4') {
                url = url + '&CategoryID=3';
                url = url + '&SubCategoryID=83';
            }
        }

        if (data.CategoryID != null && data.SubCategoryID != null) {
            url = url + '&CategoryID=' + data.CategoryID;
            url = url + '&SubCategoryID=' + data.SubCategoryID;
        }

        if (data.DestinationID != null) {
            url = url + '&DestinationID=' + data.DestinationID;
        }

        return this.http.get(url, {}, headers);

    }

}
